import { Route } from 'react-router-dom';
import { ValueMetricsPage } from './pages/ValueMetricsPage.js';
import { ValueScenarioKpisPage } from './pages/ValueScenarioKpisPage.js';

/**
 * Value — value-realisation metrics. Two pages (metrics,
 * scenario-kpis). Both reuse engine reads owned by the kpi /
 * scenario slices respectively.
 */
export function valueRoutes(): JSX.Element {
  return (
    <>
      <Route path="/value" element={<ValueMetricsPage />} />
      <Route path="/value/scenario-kpis" element={<ValueScenarioKpisPage />} />
    </>
  );
}
